import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';

export function getLocationSubheader(locations: {
  [k: string]: string;
}): string {
  const count = Object.keys(locations || {}).length;

  if (count === 0) {
    return 'Any location';
  }

  return `${count} ${getSingularOrPlural(count, 'location')}`;
}
